'use strict';

module.exports = Object.getOwnPropertyDescriptor;